export default "__VITE_ASSET__d1a75755__"